import { customToast } from '../v2/components/ToastAlert/customToast';
import { copyToClipboard } from '../v2/lib/clipboard';
import {
  AnalyticsPage,
  trackProviderEvent,
  CommonAnalyticsEvent,
} from './analytics';

export const urlFromSlug = (slug?: string): string => {
  if (!slug) {
    return '';
  }

  return `${window.location.origin}/p/${slug}`;
};

export const handleCopyMyPage = async (url: string) => {
  const ok = await copyToClipboard(url);
  if (ok) {
    customToast.success(`Link copied to clipboard: ${url}`);
  } else {
    customToast.error(
      'Could not copy to clipboard. Your browser may require HTTPS or clipboard permissions.',
    );
  }
  trackProviderEvent(CommonAnalyticsEvent.ButtonClicked, {
    buttonName: 'Share your page',
    originPage: AnalyticsPage.MyWebpage,
  });
};

export const handleSeeMyPage = (url: string) => {
  window.open(url, '_blank');
  trackProviderEvent(CommonAnalyticsEvent.ButtonClicked, {
    buttonName: 'See your page',
    originPage: AnalyticsPage.MyWebpage,
  });
};
